import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from "@/store/index"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { requiresAuth: true },
    component: Home
  },
  {
    path: '/creator-dashboard/',
    name: 'creator-dashboard',
    meta: { requiresAuth: true, creatorSidebar: true, title: "Creator Dashboard"  },
    component: () => import(/* webpackChunkName: "creator-dashboard" */ '@/components/CreatorTools/CreatorDashboard.vue'),
  },
  {
    path: '/eula/',
    name: 'eula',
    meta: { title: "End User's Licence Agreement" },
    component: () => import(/* webpackChunkName: "eula" */ '@/components/Eula.vue'),
  },
  {
    path: '/storyhub/:id',
    name: 'story-hub',
    meta: { requiresAuth: true, creatorSidebar: true, title: "Story Hub" },
    component: () => import(/* webpackChunkName: "story-hub" */ '@/components/CreatorTools/StoryHub/StoryHub.vue'),
    children: [
      {
        path: 'basic-info',
        name: 'basic-info',
        meta: { title: "Basic Info" },
        alias: ['/'],
        component: () => import(/* webpackChunkName: "basic-info" */ '@/components/CreatorTools/StoryHub/BasicInfo/BasicInfoTab.vue'),
      },
      {
        path: 'chapter-list',
        name: 'chapter-list',
        meta: { title: "Chapters" },
        component: () => import(/* webpackChunkName: "chapter-list" */ '@/components/CreatorTools/StoryHub/ChapterList/ChapterList.vue'),
      },
      {
        path: 'publishing',
        name: 'publishing',
        meta: { title: "Publishing" },
        component: () => import(/* webpackChunkName: "publishing" */ '@/components/CreatorTools/StoryHub/Publishing/Publishing.vue'),
      },
    ],
  },
  {
    path: '/auth/',
    name: 'auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/components/Auth/Auth.vue'),
    children: [
      {
        path: 'sign-in',
        name: "sign-in",
        meta: { title: "Sign In" },
        component: () => import(/* webpackChunkName: "sign-in" */ '@/components/Auth/SignIn.vue'),
      },
      {
        path: 'register/',
        name: 'register',
        meta: { title: "Register" },
        component: () => import(/* webpackChunkName: "register" */ '@/components/Auth/Register/RegisterFlow.vue'),
        children: [
          {
            path: '/',
            name: 'register-email-password',
            meta: { step: 1, title: "Account Setup" },
            component: () => import(/* webpackChunkName: "register" */ '@/components/Auth/Register/EmailPassword.vue'),
          },
          {
            path: 'profile',
            name: 'register-profile',
            meta: { step: 2, title: "Secret Identity" },
            component: () => import(/* webpackChunkName: "register" */ '@/components/Auth/Register/UserProfile.vue'),
          },
          {
            path: 'eula',
            name: 'eula',
            meta: { step: 3, title: "EULA" },
            component: () => import(/* webpackChunkName: "register" */ '@/components/Auth/Register/Eula.vue'),
          },
          {
            path: 'verification',
            name: 'verification',
            meta: { step: 4, title: "Verify" },
            component: () => import(/* webpackChunkName: "register" */ '@/components/Auth/Register/Verification.vue'),
          },
        ],
      }
    ],
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    meta: { title: "Reset Password" },
    component: () => import(/* webpackChunkName: "reset-password" */ '@/components/Auth/ResetPassword.vue'),
  },
  { path: "*", component: () => import('@/views/PageNotFound') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters['auth/getMe']) {
      next()
    }
    else {
       next({
         path: '/auth/sign-in',
         query: { redirect: to.fullPath }
       })
    }
  } else {
    next() // make sure to always call next()!
  }
})


const DEFAULT_TITLE = 'Story City';
router.afterEach((to) => {

    Vue.nextTick(() => {
      if (to.meta.title) {
        document.title = to.meta.title + " | "  + DEFAULT_TITLE;
      }
      else {
        document.title = DEFAULT_TITLE;
      }
    });
});

export default router
